// Shared helpers used by every report-PDF generator.
// Kept here so each generator file stays focused on the layout of the
// document it produces, not on formatting/footer plumbing.

export const BRAND_DARK = [26, 47, 35];      // Forest 500 (#1A2F23)
export const BRAND_LIGHT = [240, 253, 244];  // Light green tint
export const RED_500 = [220, 38, 38];
export const GREEN_500 = [34, 197, 94];

export function formatCurrency(amount) {
  if (amount === null || amount === undefined) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

// Format dates avoiding timezone shift for date-only strings.
export function formatDateLocal(dateString) {
  if (!dateString) return '-';
  if (dateString.length === 10 && dateString.includes('-')) {
    const [year, month, day] = dateString.split('-');
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US');
  }
  return new Date(dateString).toLocaleDateString('en-US');
}

// Stamp a "LandFlow / Page N of M" footer on every page of the document.
export function addFooter(doc, { brandText = 'LandFlow', disclaimer = null } = {}) {
  const pageCount = doc.internal.getNumberOfPages();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setTextColor(128, 128, 128);
    doc.setFontSize(7);
    if (disclaimer) {
      doc.text(disclaimer, 14, pageHeight - 8);
      doc.text(`${brandText} | ${new Date().toLocaleDateString()} | Page ${i} of ${pageCount}`, pageWidth - 14, pageHeight - 8, { align: 'right' });
    } else {
      doc.text(brandText, 14, pageHeight - 8);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 14, pageHeight - 8, { align: 'right' });
    }
  }
}
